/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { Row, Col,  Table, Spin, message, Tag,} from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useEffect, useReducer } from 'react';

import axios from 'axios';
import moment from 'moment';
import reducer from './reducer';
import {LOG_LIST,LOG_LIST_SUCCESS,LOG_LIST_ERROR} from './constants';
import { useNavigate } from 'react-router-dom';

import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';
import { useAuth } from '../Context';


export default function Loghistory(props) {
	
	
	
	const { userId, startDate, endDate , pipelineId } = props;
	const initalState = { pending: false, error: false, logs : [], pagination: { total: 0, limit: 10, skip: 0, current:1 }};
	const [data, dispatch] = useReducer(reducer, initalState);
	const navigate = useNavigate();
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	useAuth();

	useEffect(() => {
		if(featuresModule.allocationsEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4010);
	}, []);
	
	
	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
		loadlogs(1);
		
	},[authtoken, startDate, endDate]);
	
	

	
	const loadlogs = (pagination) => {
		let _pagination = { };
		_pagination.total = data.pagination.total ? data.pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination.current    ? parseInt((pagination.current-1) * pagination.pageSize) : 0;
		_pagination.pageSize =  pagination.pageSize ? pagination.pageSize : 10;
	
		dispatch({ type : LOG_LIST});		
		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/auditlogs?userId=${parseInt(userId)}&$sort[id]=-1&$limit=${_pagination.limit}&$skip=${_pagination.skip}&LoginDateTime[$gte]=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&LoginDateTime[$lte]=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}&pipelineId=${parseInt(pipelineId)}`,
			timeout: timeout,
			headers: { 
				'Authorization': `Bearer ${authtoken}`
			}
		};
	
		axios.request(config)
			.then((response) => {

					
					
					
				if ( response.status === 200) { 
					dispatch({ type : LOG_LIST_SUCCESS, payload : response.data, page:pagination.current, pageSize : pagination.pageSize });
						
				} else { 
					dispatch({ type : LOG_LIST_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : LOG_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	
		
		
		
	
	const columns = [
		{
			title : langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex : 'name',
			key : 'name'
		},
		{
			title : langdata && langdata.UserType ? langdata.UserType : 'User Type',
			dataIndex : 'usertype',
			key : 'usertype'
		},
		{
			title : langdata && langdata.LoginDateTime ? langdata.LoginDateTime : 'Login Date Time',
			dataIndex : 'logindate',
			key : 'logindate'
		},
		{
			title : langdata && langdata.LogoutDateTime ? langdata.LogoutDateTime :  'Logout Date Time ',
			dataIndex : 'logoutdate',
			key : 'logoutdate'
		},
		
		{
			title :  langdata && langdata.Allocations ? langdata.Duration : 'Duration',
			dataIndex : 'duration',
			key : 'duration'
		},
		{
			title :  langdata && langdata.Status? langdata.Status: 'Status',
			dataIndex : 'status',
			key : 'status',
			render: (_, { status }) => (
				<>
					<Tag color={status == 'Success' ? 'blue' : 'red'} >
						{status}
					</Tag>
				</>
			),
		},
		
				
			
	];
	
		
	return (
		<>
			<Content>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						<Table 
							scroll={{
								x: 900,
							}}
							columns={columns} dataSource={data.logs} pagination = { data.logs.length > 0 ? data.pagination : 0 } onChange={loadlogs}/>
					</Col>
				</Row>
				<Spin fullscreen spinning={data.pending} />
			</Content>
		</>
	);
}

